/*
 * PrintPage Messages
 *
 * This contains all the text for the PrintPage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  intro: {
    id: 'app.components.PrintPage.intro',
    defaultMessage: 'You can print {count, plural, one {this page} other {these pages}} using the button or the Print-function of the browser.{br}If the Preview shows headers and footers, you can adapt the Print settings of the browser to remove these.',
  },
  print: {
    id: 'app.components.Button.print',
    defaultMessage: 'Print',
  },
  greeting: {
    id: 'app.components.PrintPage.greeting',
    defaultMessage: 'Best regards,',
  },
  downloadApp: {
    id: 'app.components.PrintPage.downloadApp',
    defaultMessage: 'Tip: Receive all relevant news on your smartphone or tablet?{br}Download the Social Schools 3.0 app for iOS or Android!',
  },
});
